<template>
  <div>
    <b-modal
      ref="serverToken"
      centered
      size="lg"
      :title="`Access Token for «${selectedServer.name}»`"
      hide-footer
      @hidden="
        clearServerToken(),
        closeConfirmation()
      ">
      <template v-if="!serverTokenEmpty">
        <b-alert
          show
          variant="light-info"
          class="mb-4">
          This token is used for agent authentication and to connect the agent to the main service.
        </b-alert>
        <b-form
          id="serverToken"
          inline
          class="w-100 mb-2">
          <b-form-input
            v-model="serverToken"
            :disabled="serversResponses('regenerateServerToken')"
            id="serverToken-input"
            readonly
            class="flex-grow-1 mr-auto" />
          <b-button
            id="copyServerTokenBtn"
            v-wave
            variant="primary"
            data-clipboard-target="#serverToken-input"
            class="ml-2"
            :disabled="serversResponses('regenerateServerToken')">
            <i class="fa fa-copy fa-sm mr-1"></i>
            <span>Copy</span>
          </b-button>
        </b-form>
        <template v-if="confirmationShown">
          <b-alert
            show
            variant="light-danger"
            class="mb-0">
            <p class="mb-3">
              Wait, are you sure? Regeneration of the current access token will lead to loss of connection with the agent. Think twice before doing this!
            </p>
            <b-button
              @click="closeConfirmation"
              variant="outline-primary"
              size="sm">
              Cancel
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              class="ml-4 text-center justify-content-center flex-grow-1"
              @click="confirmRegeneration(selectedServer._id), closeConfirmation()">
              <i class="fa fa-check fa-sm"></i>
              <span>Yes, regenerate token</span>
            </b-button>
          </b-alert>
        </template>
        <template v-else>
          <b-button
            variant="link-primary"
            class="mr-2"
            size="sm"
            @click="openConfirmation">
            <i class="fa fa-redo-alt fa-sm"></i>
            <span>Regenerate Token</span>
          </b-button>
        </template>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { REGENERATE_SERVER_TOKEN, CLEAR_SERVER_TOKEN } from '@/core/services/store/servers.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import {
  showToast,
  showModal,
  hideModal,
  initClipboard,
  destroyClipboard,
} from '@/core/utils'

export default {
  name: 'ModalServerToken',
  data() {
    return {
      clipboard: null,
      confirmationShown: false,

      showToast,
      showModal,
      hideModal,
      initClipboard,
      destroyClipboard,
    }
  },
  computed: {
    ...mapGetters([
      'countryName',
      'countryFlag',

      'selectedServer',
      'selectedServerId',
      'serverStatusBadge',
      'serverToken',
      'serverTokenEmpty',
      'serversResponses',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => {
      this.showModal(type)
    })

    this.initClipboard('copyServerTokenBtn')
  },
  destroyed() {
    eventBus.$off('openModal')

    this.destroyClipboard()
  },
  methods: {
    clearServerToken() {
      this.$store.commit(CLEAR_SERVER_TOKEN)
    },

    openConfirmation() {
      this.confirmationShown = true
    },

    closeConfirmation() {
      this.confirmationShown = false
    },

    confirmRegeneration(server_id) {
      this.$store.dispatch(REGENERATE_SERVER_TOKEN, { server_id })
    }
  }
}
</script>
